import { PaymentMethodType, PaymentMethodEnum } from '@modules/husleie-framework/src/types/Payment.entity';
import { UpsellStatusType, UpsellStatusEnum } from '@modules/husleie-framework/src/types/Upsell.entity';
import { UpsellDepositSubscription } from '@modules/husleie-framework/src/types/UpsellDepositSubscription.entity';

export default class DepositSubscriptionUpsellConversionOperations {
  static apiToInternal(apiUpsell: any): UpsellDepositSubscription {
    let upsellDepositSubscription: UpsellDepositSubscription;
    let status: UpsellStatusType;
    let paymentMethod: PaymentMethodType;

    switch (apiUpsell.status) {
      case 'credit_check':
        status = UpsellStatusEnum.CREDTIT_CHECK;
        upsellDepositSubscription = { status, creditCheck: { token: apiUpsell.creditCheck?.token } };
        break;
      case 'rejected':
      case 'declined':
        status = UpsellStatusEnum.DECLINED;
        upsellDepositSubscription = { status };
        break;
      case 'payment':
        status = UpsellStatusEnum.PAYMENT;
        if (apiUpsell.payment?.type === 'stripe') {
          upsellDepositSubscription = {
            status,
            payment: {
              method: PaymentMethodEnum.STRIPE,
              stripe: {
                clientSecret: apiUpsell.payment.stripe.clientSecret,
                publicKey: apiUpsell.payment.stripe.publicKey,
              },
            },
          };
        } else if (apiUpsell.payment?.type === 'sepa') {
          paymentMethod = PaymentMethodEnum.SEPA;
          upsellDepositSubscription = { status, payment: { method: paymentMethod } };
        } else if (apiUpsell.payment?.type === 'manual') {
          paymentMethod = PaymentMethodEnum.MANUAL;
          upsellDepositSubscription = { status, payment: { method: paymentMethod } };
        } else {
          throw new Error('payment method not specified');
        }
        break;
      case 'ordered':
        status = UpsellStatusEnum.ORDERED;
        upsellDepositSubscription = { status };
        break;
      case 'complete':
        status = UpsellStatusEnum.COMPLETE;
        upsellDepositSubscription = { status };
        break;
      default:
        status = UpsellStatusEnum.OPEN;
        upsellDepositSubscription = { status };
    }

    return upsellDepositSubscription;
  }
}
